import { z } from 'zod';

export const CorrectPartyDocumentBodySchema = z.object({
  document: z.string().trim().min(1),
  reason: z.string().trim().optional(),
});

export type CorrectPartyDocumentBody = z.infer<typeof CorrectPartyDocumentBodySchema>;

export const CorrectPartyDocumentResponseSchema = z.object({
  partyId: z.uuid(),
  changedFields: z.array(z.string()),
});

export type CorrectPartyDocumentResponse = z.infer<typeof CorrectPartyDocumentResponseSchema>;
